import React, { useMemo, useState } from "react";
import numeral from "numeral";
import classnames from "classnames";
import { newPriceData } from "./pricing";
import Slider from "rc-slider";
import Tooltip from "rc-tooltip";
import { useTranslation } from "react-i18next";
import "./styles.less";
import { tryNow } from "../../utils";
import { Link } from "react-router-dom";

export const PriceList = (props) => {
  // 企业类型
  const { currentType, setCurrentType } = props;

  const { t } = useTranslation();

  const [stepValue, setStepValue] = useState(1); //活跃用户档位

  const [visible, setVisible] = useState(false);

  const [paymentType, setPaymentType] = useState("monthly");
  const currSpec = useMemo(() => {
    return newPriceData.find((item) => item.type === currentType);
  }, [currentType]);
  const onPurchase = () => {
    // setVisible(true);
    window.open("https://www.authing.cn/authingform");
  };

  const PriceListItem = (props) => {
    const {
      features,
      title,
      onPurchase,
      button,
      plans,
      theme,
      // paymentType,
      // originalPrice = "0",
    } = props;

    const { t } = useTranslation();
    const [disable, setDisable] = useState(false);
    const cls = classnames({
      "price-list-item": true,
      dark: theme === "dark",
      disable: disable,
    });
    const payeTypeStr =
      paymentType === "monthly"
        ? t("price.priceList.month-unit")
        : t("price.priceList.year-unit");

    const price = useMemo(() => {
      if (plans && plans[stepValue - 1]?.disable) {
        setDisable(true);
      }
      return (
        plans &&
        plans[stepValue - 1]?.[
          paymentType === "monthly" ? "priceByMonth" : "priceByYear"
        ]
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [plans, stepValue]);

    const priceDOM = useMemo(() => {
      if (price === "contact") {
        return (
          <div className="contact-title" style={{ color: "#215ae5" }}>
            {t("price.other.sales")}
          </div>
        );
      } else if (price) {
        if (paymentType === "monthly") {
          return (
            <div className="list-item-num-detail">
              <span className="list-item-num-icon">{t("price.unit")}</span>
              <span>{numeral(price).format("0,0")}</span>
              <span className="list-item-num-unit">/{payeTypeStr}</span>
            </div>
          );
        } else {
          return (
            <>
              <div className="list-item-num-detail">
                <span className="list-item-num-icon">{t("price.unit")}</span>
                <span>{numeral(price).format("0,0")}</span>
                <span className="list-item-num-unit">/{payeTypeStr}</span>
              </div>
              <div className="list-item-num-original-price">
                {`¥ ${numeral(plans[stepValue - 1]?.originalPrice).format(
                  "0,0"
                )} / 12${t("price.priceList.months")}`}
              </div>
            </>
          );
        }
      }
    }, [payeTypeStr, plans, price, t]);

    const _onPurchase = () => {
      if (Number(price) > 0 || price === "free") {
        tryNow();
        return;
      }
      onPurchase && onPurchase();
    };

    return (
      <div className={cls} onClick={_onPurchase}>
        <div className="item-num-warp">
          <div className="list-item-title">{title}</div>
          {plans &&
            // (Number(price) > 0 ? (
            //   <div className="list-item-num-detail">
            //     <span className="list-item-num-icon">¥</span>
            //     <span>{numeral(price).format("0,0")}</span>
            //     <span className="list-item-num-unit">/{payeTypeStr}</span>
            //   </div>
            // ) : (
            //   <div>
            //     <div className="contact-title" style={{ color: "#215ae5" }}>
            //       {price === "contact" && t("price.other.sales")}
            //     </div>
            //   </div>
            // ))}
            priceDOM}
          {!plans && (
            <div>
              <div className="contact-title">{t("price.other.sales")}</div>
            </div>
          )}
        </div>
        <div className="price-button-warp">
          <button
            className={disable ? "price-button disable" : "price-button"}
            onClick={_onPurchase}
            disabled={disable}
          >
            {!disable && (Number(price) > 0 || price === "free")
              ? `${t("common.button.try-now")}`
              : `${t("common.button.contact-us")}`}
          </button>
        </div>
        <div className="item-feature-warp">
          <div>
            {features?.map((feature, index) => {
              return (
                <div key={index} className="item-feature">
                  {typeof feature === "object" ? (
                    <>
                      <span className={feature?.tag ? "item-link" : ""}>
                        {t(`${feature.title}`)}
                      </span>
                      {!feature?.tag && (
                        <Tooltip
                          placement="bottom"
                          mouseLeaveDelay={0.001}
                          trigger={["hover"]}
                          overlay={<div>{t("price.tenants")}</div>}
                          overlayClassName="context-box-tooltip"
                        >
                          <span>
                            <i
                              className="icon authing-icon authing-question-line"
                              style={{ color: "#aaaaaa", marginLeft: 6 }}
                            ></i>
                          </span>
                        </Tooltip>
                      )}
                    </>
                  ) : (
                    t(`${feature}`)
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  const _onChange = (stepValue) => {
    setStepValue(stepValue);
  };

  return (
    <>
      <div className="price-list">
        <div className="inner">
          <div className="app-scene">{t("price.priceList.app-scene")}</div>
          <div className="price-type-warp">
            {newPriceData.map((item) => (
              <Tooltip
                overlay={<div>{t(item.typeDesc)}</div>}
                placement="bottom"
              >
                <span
                  className={
                    item.type === currentType
                      ? "price-list-type checked"
                      : "price-list-type"
                  }
                  onClick={() => {
                    setCurrentType(item.type);
                    setStepValue(1);
                  }}
                >
                  {item.type.toLocaleUpperCase()}
                </span>
              </Tooltip>
            ))}
          </div>
          <div className="list-item-bar">
            <div className="list-item-mau">
              {currentType === "b2e" ? (
                t("price.priceList.choose-mauE")
              ) : (
                <span>
                  {t("price.priceList.choose")}
                  <Tooltip
                    placement="bottom"
                    mouseLeaveDelay={0.001}
                    trigger={["hover"]}
                    overlay={<div>{t("price.banner.common-tip")}</div>}
                  >
                    <span className="mau-user">{t("price.priceList.mau")}</span>
                  </Tooltip>
                  :&nbsp;
                </span>
              )}
              <span className="mau-color">
                {numeral(currSpec?.marks[stepValue]).format("0,0")}
                {isNaN(currSpec?.marks[stepValue]) && "+"}
              </span>
            </div>
            <Slider
              min={currSpec?.min}
              max={currSpec?.max}
              defaultValue={stepValue}
              value={stepValue}
              onChange={_onChange}
              step={null}
              marks={currSpec?.marks}
              trackStyle={{
                background: "linear-gradient(-90deg, #6BA3FF 0%, #215ae5 100%)",
                height: 9,
              }}
              railStyle={{ backgroundColor: "#eee", height: 9 }}
              handleStyle={{
                borderImageSlice: 1,
                height: 20,
                width: 20,
                marginLeft: 4,
                background: "linear-gradient(180deg, #6BA3FF 0%, #215ae5 100%)",
                boxShadow: "0px 2px 4px 0px rgba(72, 85, 127, 0.11)",
              }}
              className="price-slider"
            />
            <div className="mau-tip">
              <div
                className={
                  paymentType === "monthly" ? "payment active" : "payment"
                }
                onClick={() => {
                  setPaymentType("monthly");
                }}
              >
                <div className="payment-type">
                  <div></div>
                </div>
                <span>{t("price.priceList.monthly-payment")}</span>
              </div>
              <div
                className={
                  paymentType === "yearly" ? "payment active" : "payment"
                }
                onClick={() => {
                  setPaymentType("yearly");
                }}
              >
                <div className="payment-type">
                  <div></div>
                </div>

                <span>{t("price.priceList.annual-payment")}</span>
                <div className="benefit-icon">{t("price.priceList.sale")}</div>
              </div>
              <span className="payment-desc">
                {t("price.priceList.choose-tip")}
                {/* <Tooltip
                placement="bottom"
                mouseLeaveDelay={0.001}
                trigger={["hover"]}
                overlay={<div> {t("price.priceList.choose-tip3")}</div>}
              >
                <span style={{ margin: "0 4px", cursor: "default" }}>
                  {t("price.priceList.MAU")}
                  <i
                    className="icon authing-icon authing-problem"
                    style={{ marginLeft: 6, color: "#999999" }}
                  ></i>
                </span>
              </Tooltip> */}
                {t("price.priceList.choose-tip2")}
              </span>
            </div>
          </div>

          <div className="price-item-warp">
            {/* <PriceListItem
              title={t("price.priceList.b2c.free.title")}
              onPurchase={onPurchase}
              plans={currSpec?.free}
              features={currSpec?.features.free}
            /> */}
            <PriceListItem
              title={
                currentType === "b2e"
                  ? t("price.priceList.b2e.develop.title")
                  : t("price.priceList.b2c.develop.title")
              }
              onPurchase={onPurchase}
              plans={currSpec?.developer}
              features={currSpec?.features.developer}
            />
            {currentType !== "b2e" && (
              <PriceListItem
                title={t("price.priceList.b2c.developPro.title")}
                onPurchase={onPurchase}
                plans={currSpec?.developerPro}
                features={currSpec?.features.developerPro}
              />
            )}
            <PriceListItem
              title={t("price.priceList.b2c.enterprise.title")}
              onPurchase={onPurchase}
              theme={"dark"}
              features={currSpec?.features.enterprise}
            />
          </div>
        </div>
      </div>
    </>
  );
};
